import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CreatePaymentsLinkService {
  constructor(private http: HttpClient) {}

  generate(payload: {
    ticketId: string;
    products: { price: number; quantity: number; name: string }[];
  }) {
    return this.http.post(':API_URL/payments/create-payment-link', {
      ...payload,
    });
  }
}
